import { render } from "./Notes.vue?vue&type=template&id=01e3c33b&scoped=true&bindings={}"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=01e3c33b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-01e3c33b"

export default script